import { Link, PageProps } from 'gatsby'
import clsx from 'clsx'
import { Button, Card, Divider, SEO, Title } from 'components/common'
import Layout from 'components/layouts/tow-column'

export const Head = () => <SEO title="アカウント設定" />

const IndexPage = (props: PageProps<Queries.Query>): JSX.Element => {
  return (
    <>
      <Layout title="アカウント">
        <Divider space="medium" />

        <div className={clsx('w-2/6')}>
          <Layout.Section size="large">
            <Layout.Item>
              <Title level={4} style={{ paddingTop: '24px' }}>
                アカウントと権限
              </Title>
            </Layout.Item>
          </Layout.Section>
        </div>

        <Layout.Section size="small">
          <Layout.Item>
            <Card shadow>
              <Title level={4}>スタッフ（ 0/15 ）</Title>
              <p>
                スタッフが編集してアクセスできるものをカスタマイズします。
                <br />
                このプランでは最大で15人のスタッフを追加できます。
              </p>
              <Button type="primary" className={clsx('mt-8')}>
                <Link to="/admin/settings/accounts/new">
                  スタッフを追加する
                </Link>
              </Button>
            </Card>
          </Layout.Item>
        </Layout.Section>
      </Layout>
    </>
  )
}

export default IndexPage
